import { useEffect, useState } from "react";
import { getAcTenantId, subscribeAcTenantId } from "../utils/acTenantId";

/**
 * Current Assessment Center / tab tenant id (`?currentTenantId=` on the iframe
 * URL, then session, then `AC_TENANT_ID` cookie). Updates when the resolved
 * value changes (polled / focus / visibility / popstate). Use as a React Query
 * / effect dependency or remount key so Plan & Result data refreshes.
 */
export function useAcTenantId(): string {
  const [tenantId, setTenantId] = useState(getAcTenantId);

  useEffect(() => {
    setTenantId(getAcTenantId());
    return subscribeAcTenantId((next) => {
      setTenantId(next);
    });
  }, []);

  return tenantId;
}
